import styled from "styled-components";
import { Link } from "react-router-dom";
import { Table } from "semantic-ui-react";
import { Loader } from 'semantic-ui-react';

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;

  margin: 6% auto;
`;

export const Title = styled.h1`
  width: 100%;
  margin: 0px 0px 15px 0px;
  padding: 0px;

  color: #000000;

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;

  border-bottom: 1px solid rgba(34, 36, 38, 0.15);

  display: inline-block;
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;

  & i {
    height: 75% !important;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: #000000;
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;
export const Div = styled.div``;

export const Image = styled.img`
  height: 5rem;
  width: auto;
`;

export const LabelTitle = styled.label`
  color: white;
  display: block;
  font-size: 4rem;
  font-weight: 400;
  line-height: 1em;
  text-transform: uppercase;
`;
export const LabelText = styled.label`
  color: white;
  display: block;
  font-size: 1em;
  font-weight: 700;
  text-transform: uppercase;
`;
export const Field = styled.div`
  width: ${(props) => props.width || "100%"};
  margin-top: 30px;
  display: block;

  & > div {
    margin-top: 10px;
  }
`;

export const Grid = styled.div`
  width: ${(props) => props.width || "100%"};
  margin-top: 30px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
  & > div {
    margin-top: 10px;
  }
`;
export const Grid2 = styled.div`
  width: ${(props) => props.width || "100%"};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
  display: flex;
  flex-direction: row;
  & > div {
    margin-top: 10px;
  }
  &:last-of-type {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const GridGeral = styled.div`
  text-align: center;
  itens-align: center;
  width: 100%;
  border-radius: 0.3rem;
  background-color: #767676;
  display: block;
  padding: 16px 16px 24px 16px;

  & > div {
    margin-top: 10px;
  }
`;

export const GridPrincipal = styled.div`
  text-align: center;
  itens-align: center;
  display: block;
  width: 33%;
  padding: 1rem;
  border-radius: 0.3rem;
  display: flex;
  flex-direction: row;
  & > div {
    margin-top: 10px;
  }
`;

export const Button = styled.a`
  display: block;
  width: 80%;
  box-shadow: 0 0 0 2px #fff inset !important;
  background: 0 0;
  color: #fff;
  text-shadow: none !important;
  font-size: 1rem;
  cursor: pointer;
  display: inline-block;
  min-height: 1em;

  margin: 0 0.25em 0 0;
  padding: 0.78571429em 1.5em;
  text-shadow: none;
  line-height: 1em;
  border-radius: 0.28571429rem;
  user-select: none;
  -webkit-transition: opacity 0.1s ease, background-color 0.1s ease,
    color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;
  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease,
    box-shadow 0.1s ease, background 0.1s ease;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;

  &:hover {
    background: #e0e1e2;
    outline: 0;
    border: none;
    color: rgba(0, 0, 0, 0.6);
  }
`;

export const Principal = styled.a`
  display: block;
  width: 100%;
  box-shadow: 0 0 0 2px #fff inset !important;
  background: #e0e1e2;
  text-shadow: none !important;
  font-size: 1rem;
  cursor: pointer;
  display: inline-block;
  min-height: 1em;
  color: rgba(0, 0, 0, 0.6);
  padding: 1.5rem;
  text-shadow: none;
  line-height: 1em;
  border-radius: 0.28571429rem;
  user-select: none;
  -webkit-transition: opacity 0.1s ease, background-color 0.1s ease,
    color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;
  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease,
    box-shadow 0.1s ease, background 0.1s ease;
  text-align: center;
  font-size: 1.28571429rem;
  font-weight: 700;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;

  &:hover {
    outline: 0;
    border: none;
    color: white;
    background: #767676;
  }
`;


export const ContainerPaginate = styled.div`
  display: flex;
  justify-content: center;
`;

export const SemanticLoader = styled(Loader)`

`;